import AddToCartButtonProvider from './hooks/useAddToCartButton';

import { AddToCartButtonProps } from './@types/AddToCartButtonProps';
import { VtexButton } from '../../styleguide/VtexButton';
import ButtonDataContainer from './handles/ButtonDataContainer';
import ButtonText from './handles/ButtonText';
import { useConditionLayout } from '../../ConditionLayout/hooks/useConditionLayout';

const AddToCartButton = (props: AddToCartButtonProps) => {
	const conditionData = useConditionLayout();
	return (
		<AddToCartButtonProvider {...props}>
			<VtexButton
				data-selection={props.componentId}
				handleClick={() => {
					if (conditionData?.setConditionIsTrue) {
						const { setConditionIsTrue, conditionIsTrue } = conditionData;
						setConditionIsTrue(!conditionIsTrue);
					} else {
						window.location.hash = 'product-1';
					}
				}}
			>
				<ButtonDataContainer>
					<ButtonText />
				</ButtonDataContainer>
			</VtexButton>
		</AddToCartButtonProvider>
	);
};

export default AddToCartButton;
